import { z } from 'zod';
import { aliasRegex } from '../common/alias.js';
import { userRoles } from './roles.js';

export const userRoleSchema = z.enum(userRoles);

export const userDtoSchema = z.object({
  id: z.string().uuid(),
  alias: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string().max(255).nullable(),
  phone: z.string().max(50).nullable(),
  role: userRoleSchema,
  disabledAt: z.string().datetime().nullable(),
  lastLoginAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const adminCreateUserSchema = z.object({
  alias: z
    .string()
    .min(3)
    .max(64)
    .regex(aliasRegex, { message: 'Caractères autorisés : a-z 0-9 . _ -' }),
  firstName: z.string().min(1).max(100),
  lastName: z.string().min(1).max(100),
  email: z
    .string()
    .email()
    .max(255)
    .optional()
    .or(z.literal(''))
    .transform((v) => (v === '' ? undefined : v)),
  phone: z.string().max(50).optional(),
  password: z
    .string()
    .min(12, { message: 'Le mot de passe doit contenir au moins 12 caractères' })
    .max(200),
  role: userRoleSchema.default('member'),
});

export type UserDto = z.infer<typeof userDtoSchema>;
export type AdminCreateUserInput = z.infer<typeof adminCreateUserSchema>;
